var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardInfo"},[_c('div',[_c('p',[_vm._v("活跃用户")]),_c('p',[_vm._v(_vm._s(_vm.activeUser))])]),_c('div',[_c('p',[_vm._v("新增用户")]),_c('p',[_vm._v(_vm._s(_vm.newUser))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }